"use client";

import React from "react";
import { ArrowLeft, Gift } from "react-bootstrap-icons";
import { Button, Progress, cn } from "@heroui/react";

import { useEstimatedTime } from "../hooks/useEstimatedTime";

import { useAnswerContext } from "./AnswerContext";

const WizardNavigation = React.memo(() => {
  const { questionHistory, journeyData, handleGoBack, progressPercent } =
    useAnswerContext();
  const { displayText } = useEstimatedTime();

  return (
    <div className={cn("mb-6")}>
      <div className="flex items-center justify-between mb-4">
        {questionHistory.length > 0 && (
          <Button
            aria-label="Go back to previous question"
            className={cn(
              "text-sm",
              "text-gray-300",
              "hover:text-white",
              "px-3 py-2",
              "bg-slate-800/60 hover:bg-slate-700/70",
              "border border-gray-600/50 hover:border-gray-500",
              "backdrop-blur-sm",
              "transition-all duration-200",
              "hover:shadow-lg hover:shadow-blue-500/20",
            )}
            color="default"
            size="sm"
            variant="ghost"
            onPress={handleGoBack}
          >
            <ArrowLeft className={cn("h-4", "w-4")} />
            Back
          </Button>
        )}
        {displayText && (
          <p
            className={cn(
              "text-sm",
              "text-gray-300",
              "flex items-center justify-end",
              "bg-slate-800/40 px-3 py-2 rounded-lg",
              "border border-slate-600/30",
              "backdrop-blur-sm",
            )}
          >
            <Gift
              className={cn("inline", "mr-2", "text-blue-400", "h-4", "w-4")}
            />
            <span>{displayText}</span>
          </p>
        )}
      </div>
      {journeyData && journeyData.questions.length > 0 && (
        <>
          <div className="relative">
            <Progress
              disableAnimation
              aria-label={`${progressPercent.toFixed(0)}%`}
              className="mb-3"
              classNames={{
                base: "max-w-full",
                track:
                  "bg-slate-700/50 border border-slate-600/30 backdrop-blur-sm",
                indicator:
                  "bg-gradient-to-r from-blue-500 to-purple-500 shadow-lg",
              }}
              value={progressPercent}
            />
            {/* Progress glow effect */}
            <div
              className="absolute top-0 left-0 h-full bg-gradient-to-r from-blue-400/30 to-purple-400/30 rounded-full blur-sm pointer-events-none"
              style={{ width: `${progressPercent}%` }}
            />
          </div>
        </>
      )}
    </div>
  );
});

WizardNavigation.displayName = "WizardNavigation";

export default WizardNavigation;
